import './InformationOverlay.css';
export var freeformWrapper = '_by0m3w5-3-15-1';
export var prefixVariants = {primary:'_by0m3w0-3-15-1',success:'_by0m3w1-3-15-1',warning:'_by0m3w2-3-15-1',critical:'_by0m3w3-3-15-1',neutral:'_by0m3w4-3-15-1'};